import React from "react";

function GuardEmergency() {
    return (
        <div>
            <h2>Emergency Procedures & Fire Safety</h2>
            <p>
                Security guards must be prepared to respond quickly and effectively to emergencies. This module covers fire safety, evacuation procedures, and how to assist during medical or security incidents.
            </p>

            <h3>Fire Safety Awareness</h3>
            <ul>
                <li>Know the location of fire exits, alarms, and extinguishers</li>
                <li>Understand the fire triangle: heat, fuel, oxygen</li>
                <li>Recognize fire classes (A–F) and appropriate extinguishers</li>
                <li>Raise the alarm immediately if fire is detected</li>
            </ul>

            <h3>Evacuation Procedures</h3>
            <ul>
                <li>Follow the site’s Emergency Action Plan (EAP)</li>
                <li>Guide people to the nearest safe exit</li>
                <li>Do not use lifts during evacuation</li>
                <li>Assist vulnerable individuals if safe to do so</li>
                <li>Report to the assembly point and account for people</li>
            </ul>

            <h3>Medical Emergencies</h3>
            <ul>
                <li>Call 999 and provide clear, accurate information</li>
                <li>Provide basic first aid if trained</li>
                <li>Use AEDs (defibrillators) if available and trained</li>
                <li>Stay with the casualty and offer reassurance</li>
                <li>Record the incident and actions taken</li>
            </ul>

            <h3>Security Incidents</h3>
            <ul>
                <li>Report suspicious behavior or packages</li>
                <li>Follow lockdown or evacuation protocols</li>
                <li>Assist emergency services on arrival</li>
                <li>Preserve evidence and secure the scene if needed</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> A fire alarm activates during a busy shift. What are your immediate actions, and how do you ensure a safe evacuation?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.hse.gov.uk/toolbox/fire.htm" target="_blank" rel="noreferrer">HSE – Fire Safety at Work</a></li>
                <li><a href="https://www.stjohn.org.uk/" target="_blank" rel="noreferrer">St John Ambulance – First Aid Advice</a></li>
                <li><a href="https://www.gov.uk/government/publications/fire-safety-risk-assessment-offices-and-shops" target="_blank" rel="noreferrer">UK Gov – Fire Risk Assessment Guide</a></li>
            </ul>
        </div>
    );
}

export default GuardEmergency;
